var _ = require('underscore');
var Solr = require('Solr');

module.exports.run = function (options) {
    var attachments = options.attachments;
    var record = options.record;
    var ids = attachments.pluck('id');
    
    _.each(ids, function (id) {
        var attachment = attachments.get(id);
        attachment.destroy({ data: { zone: attachment.get('zone') }, processData: true });
        Solr.delete({ id: attachment.id });
    });
    var recordDestroy = record.destroy({
        data: {
            'zoneKey': options.record.get("zoneKey") + "",
            'location': options.record.get("location") + ""
        }, processData: true 
    });
    record.trigger('delete', record);
    return recordDestroy;
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionDelete.js